import { Link } from 'react-router-dom';
import type { Movie } from '@/types';

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-sm"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} ${movie.categoryName}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 font-label text-xs font-bold text-background-50">
          {movie.score.toFixed(1)}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-primary-950/80 px-2 py-0.5 text-xs text-background-50">
          {movie.categoryName}
        </span>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3 md:p-3.5">
        <h3 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-[15px]">
          {movie.title}
        </h3>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{movie.region}</span>
        </div>
        <div className="mt-auto flex flex-wrap gap-1">
          {movie.genres.slice(0, 2).map((genre) => (
            <span key={genre} className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}